'use client'
import React, { FC, useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import type { Page } from '@/payload-types'

import { CMSLink } from '@/components/Link'
const RichText = dynamic(() => import('@/components/RichText'))
import Image from '@/components/Image'

export const HighImpactHero: FC<Page['hero']> = ({ links, media, richText }) => {
  const [bgX, setBgX] = useState(0)

  useEffect(() => {
    let frameRequest: number

    function onFrame() {
      setBgX(bgX - 0.01)
      frameRequest = window.requestAnimationFrame(onFrame)
    }

    frameRequest = window.requestAnimationFrame(onFrame)
    return () => {
      window.cancelAnimationFrame(frameRequest)
    }
  })

  return (
    <div className={'overflow-hidden'}>
      <div className="relative h-full flex items-center justify-center text-white rotate-1 scale-105">
        <div className={'flex w-full flex-col -rotate-2 shadow-2xl mt-12'}>
          <div
            className={'h-[20px] sm:h-[40px] w-full -mb-[1px]'}
            style={{
              backgroundImage: `url(/media/film-strip-top.png)`,
              backgroundSize: 'contain',
              backgroundRepeat: 'repeat-x',
              backgroundPosition: `${bgX}rem 0`,
            }}
          ></div>
          <div className={'bg-primary'}>
            <div className="container mb-8 my-4 py-4 z-10 relative flex items-center justify-center">
              <div className="max-w-[36.5rem] text-center">
                {richText && (
                  <RichText
                    className="mb-6"
                    content={richText}
                    enableProse={false}
                    enableGutter={false}
                  />
                )}
                <div className="flex justify-center gap-4">
                  {Array.isArray(links) &&
                    links.length > 0 &&
                    links.map(({ link }, i) => {
                      return (
                        <div key={i}>
                          <CMSLink {...link} />
                        </div>
                      )
                    })}
                </div>
              </div>
            </div>
          </div>
          <div
            className={'h-[20px] sm:h-[40px] w-full -mt-[1px]'}
            style={{
              backgroundImage: `url(/media/film-strip-bottom.png)`,
              backgroundSize: 'contain',
              backgroundRepeat: 'repeat-x',
              backgroundPosition: `${bgX}rem 0`,
            }}
          ></div>
        </div>
        <div className="min-h-[100vh] select-none">
          {media && typeof media === 'object' && media.url && (
            <Image
              fill
              className="-z-10 object-cover"
              style={{ objectPosition: '50% 40%' }}
              alt={'Achtergrond foto'}
              priority={true}
              // The LCP image on the home page: fetch it before anything else. Next's `priority`
              // only preloads it; it doesn't set the fetch priority on its own.
              fetchPriority="high"
              // Full-bleed background, so the viewport width is the display width.
              sizes="100vw"
              src={media.url}
            />
          )}
        </div>
      </div>
    </div>
  )
}
